const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

export { pipe };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/pipe.mjs
// module id = uDXF
// module chunks = 0